import React from 'react';
import axios from 'axios';
import { Button, Modal, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';

var AddPass = React.createClass({

	getInitialState: function() {

		return {
			addObject: {
				id: '',
				numerPass: '',
				iloscCm: '',
				ilot: '',
			}
		}
    },

	render: function() {

		return (
			<Modal show={this.props.parent.state.showAddModal}>
				<Modal.Header>
					<Modal.Title>Dodaj Listwę passepartout</Modal.Title>
				</Modal.Header>
				<Modal.Body>
						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Numer Listwy passepartout: </ControlLabel>
							</div>
							<div className="col-sm-8">
							<FormControl
								type="text"
								placeholder="Numer Listwy"
								value={this.state.addObject.numerPass}
								onChange={this.onAddPassNumerChange} />
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Ilość cm: </ControlLabel>
							</div>
							<div className="col-sm-8">
							<FormControl
								type="text"
								placeholder="Ilość cm"
								value={this.state.addObject.iloscCm}
								onChange={this.onAddPassIloscChange} />
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<ControlLabel>Ilot: </ControlLabel>
							</div>
							<div className="col-sm-8">
							<FormControl
								type="text"
								placeholder="Ilot"
								value={this.state.addObject.ilot}
								onChange={this.onAddPassIlotChange} />
							</div>
						</div>


				</Modal.Body>
				<Modal.Footer>
					<Button onClick={this.props.parent.closeAddModal}>Zamknij</Button>
					<Button bsStyle="primary" onClick={this.onAddBtnClicked}>Dodaj</Button>
				</Modal.Footer>
			</Modal>
		);
	},

	clearAddObject: function() {
		this.state.addObject.id = '';
		this.state.addObject.numerPass = '';
		this.state.addObject.iloscCm = '';
    this.state.addObject.ilot = '';
	},

	onAddPassNumerChange: function(event) {
		this.state.addObject.numerPass = event.target.value;
		this.forceUpdate();
	},

	onAddPassIloscChange: function(event) {
		this.state.addObject.iloscCm = event.target.value.replace(/,/g, '.');
		this.forceUpdate();
	},

	onAddPassIlotChange: function(event) {
		this.state.addObject.ilot = event.target.value;
		this.forceUpdate();
	},

	onAddBtnClicked: function() {
		axios.post('http://217.182.200.222:8080/stanPass/', this.state.addObject)
			.then(function (response) {
				this.props.parent.closeAddModal();
				this.props.parent.refreshTable();
			}.bind(this))
			.catch(function (error) {
				alert("Błędnie wprowadzone dane");
				console.log(error);
			});
	}
});

export default AddPass;



// WEBPACK FOOTER //
// ./src/components/StanPass/AddPass.js